import React from 'react';

const LadyAtDeskIcon: React.FC = () => (
  <svg width="92" height="112" viewBox="0 0 92 112" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M54.374 58.7128L52.5247 58.7713C51.691 58.7778 51.3155 58.2838 51.2979 57.4114C51.2796 56.466 52.0413 56.0297 52.94 56.1309L54.1483 56.1207C54.8673 56.2016 55.5495 55.9358 56.2355 55.7083C57.632 55.2432 59.3008 55.6043 60.6155 56.0247C61.4407 56.2876 65.433 57.7443 64.2552 58.7316C63.6418 59.2458 60.4725 58.4824 58.2622 59.1599C58.1536 59.1931 56.845 59.2422 54.374 58.7128Z"
      fill="#F1B4A7"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M37.3807 102.871C37.3807 101.073 35.8373 99.6152 33.933 99.6152H12.1125C10.2089 99.6152 8.66553 101.073 8.66553 102.871H8.69765C9.52669 102.871 10.1309 103.543 10.0888 104.324C10.0773 104.536 10.0949 104.756 10.1477 104.981C10.3664 105.917 11.1985 106.669 12.1997 106.828C13.8096 107.084 15.2046 105.919 15.2046 104.446C15.2046 104.389 15.2023 104.333 15.1977 104.276C15.1396 103.515 15.7828 102.871 16.5919 102.871H30.1495C30.9778 102.871 31.5828 103.543 31.5399 104.324C31.5285 104.536 31.5468 104.756 31.5996 104.98C31.8175 105.917 32.6504 106.668 33.6515 106.828C35.2614 107.084 36.6557 105.919 36.6557 104.446C36.6557 103.841 36.4125 103.295 36.0232 102.871H37.3807Z"
      fill="#A8B5B1"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M54.0671 66.6202C53.8767 66.3854 53.6518 66.1688 53.3834 66.0012C46.5438 61.7213 39.4174 54.8327 31.257 51.9843C24.5298 49.6363 19.0202 54.0231 18.9483 58.2907C18.9467 58.3666 18.946 58.4431 18.9444 58.5175C18.8917 62.003 21.3245 65.0854 24.8716 66.0482C30.87 67.676 38.7925 70.3439 45.3239 72.0766C41.5481 78.3317 36.4905 88.8546 33.8963 91.2617C33.3204 91.82 32.6932 92.3545 32.2 92.5827C30.9709 93.1532 29.5813 93.0514 28.1664 94.9949C26.7515 96.9391 25.8957 100.253 24.3623 101.565C22.8281 102.877 23.4315 104.689 25.8307 102.055C25.8307 102.055 29.904 98.0102 32.1013 96.305C33.5177 95.2058 35.2874 93.1713 36.5861 92.067C36.8193 91.8691 36.9539 91.6127 36.9952 91.3469C41.3921 86.9024 50.6798 77.2376 55.1982 70.4776C55.9959 69.283 55.4032 67.5388 54.0671 66.6202Z"
      fill="#E88265"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M35.5187 66.9775H25.0233C29.1364 66.2488 32.2767 62.8254 32.2767 58.7376V36.5422C32.2767 31.9294 28.2798 28.1543 23.3943 28.1543H9.63706C4.75152 28.1543 0.753906 31.9294 0.753906 36.5422V58.7376C0.753906 62.9619 4.10832 66.4741 8.42485 67.0374C6.91437 67.3177 5.76411 68.5794 5.76411 70.0845C5.76411 71.7933 7.24476 73.1922 9.05505 73.1922H35.5187C37.3282 73.1922 38.8088 71.7933 38.8088 70.0845C38.8088 68.3757 37.3282 66.9775 35.5187 66.9775Z"
      fill="#E88069"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M24.8716 66.0482C21.3245 65.0854 18.8917 62.003 18.9444 58.5175C18.946 58.4431 18.9467 58.3666 18.9483 58.2907C19.0202 54.0231 24.5298 49.6363 31.257 51.9843C39.4174 54.8327 46.5438 61.7213 53.3834 66.0012C54.679 66.8115 32.2275 68.0451 24.8716 66.0482Z"
      fill="#6E858A"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M44.5905 72.4021C44.2945 74.6273 42.4521 76.0342 40.5202 75.5322C33.5781 73.7274 21.5019 69.1824 14.423 66.4336C11.0089 65.1083 8.95005 61.7926 9.40817 58.3339C9.41811 58.2602 9.42805 58.1844 9.43876 58.1085C10.0062 53.8741 15.9939 50.0861 22.4067 53.1187C30.1855 56.7963 36.596 63.284 42.8957 68.2471C44.0895 69.1882 44.8069 70.78 44.5905 72.4021Z"
      fill="#DE6879"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M45.6783 71.7798C45.6783 67.8639 39.5056 66.2504 38.1404 71.3681C36.7592 76.5457 35.4491 90.6125 33.9906 95.3113C33.6977 96.2163 33.2962 97.2613 32.8648 97.777C32.0167 98.7924 30.7157 99.2655 30.3265 101.596C29.9372 103.926 30.6783 107.264 29.8928 109.073C29.1081 110.88 30.4794 112.271 31.4415 108.916C31.4415 108.916 33.3344 103.78 34.5374 101.348C35.0567 100.299 35.6862 98.887 36.2475 97.608C37.462 95.6045 45.6783 81.6793 45.6783 71.7798Z"
      fill="#E88265"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M31.8664 2.45757C30.3379 1.38693 28.484 0.696484 26.4253 0.645891C24.1972 0.590834 21.7012 1.22101 20.1428 2.61306C18.0045 4.5222 17.7823 6.41126 17.9376 8.94686C18.0108 10.1499 17.9966 11.4081 17.3593 12.4854C15.4565 15.6995 10.1983 16.1422 10.1605 20.4084C10.1447 22.1873 11.228 23.9469 12.9606 24.9551C9.97689 26.3047 8.28376 29.3537 8.73915 32.1899C9.19454 35.0253 11.6558 37.517 14.7939 38.5869C17.9502 39.6627 21.661 39.1903 24.8204 38.3257C27.8458 37.4984 29.5272 33.8096 29.2467 31.3298C29.1742 30.6884 26.8397 25.6076 26.274 26.1187C29.056 23.6032 31.8664 21.0542 33.8384 18.0409C35.8104 15.0269 36.8883 11.4527 35.946 8.10166C35.3424 5.95666 33.8896 3.87417 31.8664 2.45757Z"
      fill="#302E4F"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M53.193 55.7616C47.0509 53.2836 39.3631 49.3128 39.6453 47.5022C40.17 44.128 39.1505 27.8793 38.4568 24.5354C37.9352 22.0192 35.2232 20.1681 33.2003 20.3617C29.6968 20.6975 19.3162 19.1953 19.3162 19.1953C19.3162 19.1953 5.50771 48.722 11.1902 54.6847C11.7194 55.2394 21.3674 61.0266 29.1056 61.0266C34.8821 61.0266 37.1452 59.6493 38.5815 58.9025C38.9279 58.722 39.1925 58.5241 39.4113 58.3197C42.8261 59.489 47.2757 59.7974 52.7104 58.948C53.4729 58.8289 53.9042 56.0483 53.193 55.7616Z"
      fill="#EFC33B"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M27.8078 3.45703C24.3708 3.45703 23.089 5.7667 23.024 10.0394C22.9995 11.6398 23.7613 13.2251 24.3746 14.2377C24.8312 14.9895 24.9559 15.88 24.6959 16.7113L23.941 19.1228C23.4286 21.3602 24.5536 22.5866 26.2148 23.0322C27.0369 23.2532 28.0227 23.082 28.7409 22.6436C29.5959 22.1229 29.6655 21.0013 29.5072 20.0523L29.3122 19.3647C29.0491 18.4388 29.6181 17.44 30.6101 17.2356C33.2555 16.6889 33.6348 14.0846 34.3438 10.0394C35.0826 5.82304 31.2433 3.45703 27.8078 3.45703Z"
      fill="#E88265"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M27.1994 22.4739C27.1994 22.4739 28.2728 17.4638 29.4712 16.9701C30.2524 16.6479 32.0071 18.0553 32.8463 17.4244C33.0981 17.2349 33.4025 15.3246 33.689 14.0738C33.7616 13.7585 34.6367 14.4363 34.7019 14.0859C34.7775 13.6765 33.6453 11.5677 33.8432 11.164C36.9134 4.90426 25.5312 1.24865 23.487 6.24109C22.2078 9.36612 22.7241 13.0921 25.2983 15.8189L24.8287 18.8006L27.1994 22.4739Z"
      fill="#E48868"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M33.4026 5.19321C32.8791 3.08065 29.3147 4.7314 28.7217 5.82022C28.3612 6.48164 28.2777 7.22567 28.2624 7.95405C28.2326 9.37014 28.4414 10.7894 28.3062 12.2011C28.171 13.6134 27.6356 15.0727 26.3885 16.0182C24.3263 17.5819 19.5944 16.9662 19.7872 14.1928C19.8588 13.1672 20.3935 12.1435 20.9256 11.2355C21.031 11.0559 21.9322 10.0053 21.8633 9.83257C21.8606 9.82694 19.2253 3.24898 25.2229 2.11448C26.4978 1.87294 27.5687 1.74341 28.4632 1.68897C30.7898 1.54692 32.8711 3.04999 33.4026 5.19321Z"
      fill="#302E4F"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M28.2774 58.7787L26.5574 58.6523C25.7245 58.6053 25.1157 58.1482 25.1616 57.2765C25.2113 56.3325 26.0029 55.9468 26.8924 56.1057L28.0977 56.1729C28.8097 56.3007 29.5087 56.0797 30.2101 55.8963C31.6372 55.5236 33.2761 55.9909 34.5572 56.495C35.361 56.8121 39.1422 59.6554 37.6944 59.7724C36.8768 59.8382 34.3239 58.2392 32.0701 58.7722C31.9592 58.7982 30.7049 59.4669 28.2774 58.7787Z"
      fill="#E88265"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M16.7467 19.903C16.7467 19.903 6.74007 36.9634 5.49574 46.4217C4.64529 52.8899 14.463 56.6332 26.3205 59.0931C27.0753 59.2498 28.1323 56.5696 27.5847 56.054C22.8552 51.6007 13.1682 47.7043 14.141 46.1219C15.9551 43.1731 21.3944 27.7276 22.0651 24.3801C22.7351 21.0326 19.357 17.4496 16.7467 19.903Z"
      fill="#EFC33B"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M37.3739 74.638C37.3739 74.638 38.17 66.5859 54.0863 66.7816C54.2331 66.7838 54.2996 66.6069 54.1788 66.5267L51.0454 64.4532C51.0454 64.4532 37.8457 64.342 33.8887 73.5315L37.3739 74.638Z"
      fill="#DE6879"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M12.6448 64.4525H91.7596V58.7324H12.6448V64.4525Z"
      fill="#D1E2DE"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M20.228 111.473H25.535V62.2129H20.228V111.473Z"
      fill="#D1E2DE"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M82.7053 111.473H88.0123V62.2129H82.7053V111.473Z"
      fill="#D1E2DE"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M39.4443 58.7266H72.1885L76.3808 60.733H44.065L39.4443 58.7266Z"
      fill="#49478A"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M44.0652 57.9996L45.2713 41.9219H75.1664L76.3809 60.7306H44.0652V57.9996Z"
      fill="#393762"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M60.4696 49.1364C60.2056 49.1364 59.9581 49.1833 59.7314 49.2762C59.1049 49.5305 58.6359 50.1064 58.5365 50.7429C58.464 51.2015 58.5779 51.6855 58.8502 52.0737C59.2074 52.5851 59.8712 52.9038 60.5804 52.9038C60.9304 52.9038 61.2628 52.8227 61.5424 52.6692C62.4173 52.19 62.7869 51.0196 62.3303 50.167C62.0021 49.55 61.2545 49.1364 60.4696 49.1364ZM60.5806 53.4974C59.6642 53.4974 58.7996 53.077 58.3254 52.4013C57.9692 51.8929 57.8212 51.2573 57.9164 50.656C58.0469 49.8229 58.6609 49.068 59.481 48.7327C59.7874 48.6075 60.1198 48.5449 60.4698 48.5449C61.4856 48.5449 62.4599 49.0895 62.8927 49.9011C63.4995 51.0392 63.0263 52.5421 61.8562 53.1835C61.4824 53.3898 61.0414 53.4974 60.5806 53.4974Z"
      fill="#49478A"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M42.0307 84.5834C41.9708 84.5021 41.9488 84.3973 41.9814 84.3001C43.1587 80.7522 44.2409 77.5592 45.5442 74.4224C45.6081 74.2688 45.7946 74.2013 45.9599 74.2773C46.1236 74.3493 46.2061 74.5362 46.1418 74.6927C44.8468 77.81 43.7686 80.9913 42.5934 84.5302C42.541 84.6891 42.3604 84.7681 42.1917 84.7046C42.1258 84.6799 42.0702 84.6369 42.0307 84.5834Z"
      fill="#BA745D"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M15.3159 43.1933C15.3067 43.1913 15.2977 43.1885 15.2885 43.1866C15.1388 43.1395 15.0572 42.9877 15.1071 42.8462L19.9473 28.9717C20.4127 27.6406 20.8926 26.2644 20.8886 24.8524C20.8845 23.3231 20.2441 21.9952 19.1786 21.299C19.0493 21.2143 19.0168 21.0464 19.1064 20.9243C19.1953 20.8012 19.3738 20.7715 19.5022 20.8559C20.7232 21.6523 21.4544 23.1459 21.4593 24.851C21.4638 26.3504 20.9683 27.7679 20.4894 29.1398L15.649 43.0152C15.603 43.1484 15.4572 43.2231 15.3159 43.1933Z"
      fill="#E8A12B"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M33.6692 21.2985C33.6678 21.2991 33.6649 21.3002 33.6635 21.3008C33.5435 21.3509 33.4868 21.4737 33.5351 21.5751C33.981 22.5152 33.7079 23.0072 33.1658 23.9869L33.0601 24.1774C32.9794 24.3253 32.8886 24.4713 32.7971 24.6176C32.5157 25.0693 32.2245 25.5369 32.2029 26.0622C32.1754 26.6949 32.5386 27.2131 32.89 27.7138C32.979 27.8415 33.0684 27.9684 33.1499 28.0962C33.7066 28.969 33.9411 30.0176 33.811 31.049C33.7525 31.5049 33.6234 31.9712 33.4978 32.4224C33.3128 33.0898 33.1216 33.7795 33.1455 34.4766C33.1693 35.2117 33.4271 35.8902 33.6753 36.5467L33.7528 36.7497L37.4206 46.4535C37.4606 46.5588 37.5922 46.61 37.7139 46.5678C37.7175 46.5664 37.7211 46.565 37.7232 46.5642C37.8402 46.5187 37.9025 46.403 37.8638 46.3008L34.1175 36.3936C33.8793 35.764 33.6321 35.1135 33.6098 34.4373C33.5883 33.7957 33.7637 33.1636 33.95 32.4935C34.0783 32.0291 34.2117 31.5498 34.2727 31.0671C34.4135 29.9529 34.1606 28.8199 33.56 27.877C33.4757 27.7445 33.3834 27.6131 33.2904 27.4818C32.9592 27.0084 32.6451 26.5627 32.6672 26.05C32.6856 25.6246 32.9364 25.2213 33.201 24.7962C33.297 24.6431 33.3921 24.4896 33.4775 24.335L33.5812 24.146C34.1293 23.1569 34.4917 22.5021 33.9656 21.3951C33.9189 21.2953 33.7869 21.2528 33.6692 21.2985Z"
      fill="#EAA92F"
    />
  </svg>
);

export default LadyAtDeskIcon;
